import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { search_svg } from "../../../constant/imagePath";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import classes from "./SearchResultsMobile.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { ReactSVG } from "react-svg";
import { Button } from "../../../stories/Button/Button";
import SearchResultsModal from "../../../components/Modals/StudentFlow/SearchResultsModal/SearchResultsModal";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import { CoachCardWithFavouriteIconMobile } from "../../../stories/CoachCardWithFavouriteIconMobile/CoachCardWithFavouriteIconMobile";
import MapWithCoachesModal from "../../../components/Modals/StudentFlow/SearchResults/MapWithCoachesModal/MapWithCoachesModal";
import CoachFiltersModal from "../../../components/Modals/StudentFlow/SearchResults/CoachFiltersModal/CoachFiltersModal";

const SearchResultsMobile = () => {
  const [data, setData] = useState([1, 2, 3, 3]);
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setpaginatedData] = useState([]);
  const [openMapModal, setOpenMapModal] = useState(false);
  const [openFiltersModal, setOpenFiltersModal] = useState(false);

  const pagelimit = 3;
  useEffect(() => {
    setpaginatedData(() => {
      const startIndex = currentPage * pagelimit - pagelimit;
      const endIndex = startIndex + pagelimit;
      return data?.slice(startIndex, endIndex);
    });
  }, [currentPage]);

  const [iconClicked, setIconClicked] = useState("");

  const handleFilterModal = () => {};
  console.log(show);
  return (
    <>
      <Container fluid className={classes.main_cont}>
        <div className={classes.headerMain}>
          <MobileHeader isLogo={true} />
        </div>
        <div className={classes.inputDiv}>
          <InputWithSearchIcon
            onFilter={() => setOpenMapModal(true)}
            isShowFilter={true}
          />
        </div>
        {data?.length == 0 ? (
          <div className={classes.parent}>
            <div className={classes.noResultMain}>
              <ReactSVG src={search_svg} className={classes.search_svg} />
              <p
                style={{
                  ...Fonts.h4,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "26px",
                  lineHeight: "36px",
                  marginBottom: "20px",
                }}
                className={[classes.mb28].join(" ")}
              >
                No results
              </p>
              <p
                className={classes.p_text}
                style={{
                  ...Fonts.p1,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                Try adjusting your search filters to see available coaches
              </p>

              <Button
                label={"Clear filters"}
                primary={true}
                customStyle={{
                  ...Fonts.b1,
                  width: "200px",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  margin: "19px auto",
                }}
              />
            </div>
          </div>
        ) : (
          <>
            <div className={classes.cards}>
              {paginatedData?.map(() => {
                return (
                  <div>
                    <CoachCardWithFavouriteIconMobile />
                  </div>
                );
              })}
            </div>
          </>
        )}
        {paginatedData?.length > 0 && (
          <div className={classes.pagination}>
            <PaginationComponent
              totalPages={Math.ceil(data.length / pagelimit)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        )}
      </Container>
      <MobileFooter />
      {/* <SearchResultsModal show={show} setShow={setShow} /> */}
      <MapWithCoachesModal
        show={openMapModal}
        setShow={setOpenMapModal}
        onCard={() => setOpenFiltersModal(true)}
      />
      <CoachFiltersModal
        show={openFiltersModal}
        setShow={setOpenFiltersModal}
      />
    </>
  );
};

export default SearchResultsMobile;
// Bilal Bhai Card Structure
{
  /* <div className={classes.cardMain}>
<Row>
  <Col md={3} xs={3}>
    <img
      className={`img-fluid ${classes.imgCoach}`}
      src={coachDemoImg}
    />
  </Col>
  <Col md={9} xs={9}>
    <Row style={{ height: "100%" }}>
      <div className={classes.flexer1}>
        <div>
          <Col md={12}>
            <h5>Benedict Cumberbatch</h5>
          </Col>
          <Col md={12}>
            <div className={classes.flexer}>
              <StarIcon
                style={{ fill: "#F93749" }}
                sx={{ fontSize: 16 }}
              />{" "}
              <p
                style={{
                  ...Fonts.h9,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                4.7
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  className={[classes.dots].join(" ")}
                  style={{
                    backgroundColor: Colors.neutralShadesOfDimGray,
                  }}
                />
              </div>
              <p
                style={{
                  fontFamily: "Sequel_100 Wide W05_55",
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
              >
                $75
              </p>
              <p style={{ ...Fonts.h9 }}>/hr</p>
            </div>
          </Col>
        </div>
      </div>
    </Row>
  </Col>
</Row>
<Row>
  <Col md={12}>
    <p
      style={{
        ...Fonts.p2,
      }}
      className={classes.desc}
    >
      Professionally experienced knowledgeable coach of athletes
      from youths through collegiate level in tennis...
    </p>
  </Col>
  <Col md={12}>
    <div className={classes.locationDiv}>
      <FmdGoodIcon
        style={{ fill: "#717171", marginRight: "5px" }}
        sx={{ fontSize: 16 }}
      />
      <p style={{ ...Fonts.p2 }}>0.6 m away</p>
      <span
        className={[classes.dots].join(" ")}
        style={{
          backgroundColor: Colors.neutralShadesOfDimGray,
        }}
      />
      <p style={{ ...Fonts.p2 }}>Tennis</p>
    </div>
  </Col>
</Row>
</div> */
}
